var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcoCopyGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_415",
    "data-name": "Group 415",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_51",
    "data-name": "Subtraction 51",
    d: "M8,10H2A2,2,0,0,1,0,8V2A2,2,0,0,1,2,0H8a2,2,0,0,1,2,2V8A2,2,0,0,1,8,10ZM2.769.769a2,2,0,0,0-2,2V7.231a2,2,0,0,0,2,2H7.231a2,2,0,0,0,2-2V2.769a2,2,0,0,0-2-2Z",
    transform: "translate(2 2)",
    fill: "#d1d1d1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_52",
    "data-name": "Subtraction 52",
    d: "M2.308,10H2A2,2,0,0,1,0,8V2A2,2,0,0,1,2,0H8a2,2,0,0,1,2,2v.308H9.176A1.99,1.99,0,0,0,7.231.769H2.769a2,2,0,0,0-2,2V7.231A1.99,1.99,0,0,0,2.308,9.176V10Z",
    transform: "translate(0 0)",
    fill: "#d1d1d1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCopyGrey);
export default __webpack_public_path__ + "static/media/ico_copy_grey.3847b8918f8bab68b9624bb61cade128.svg";
export { ForwardRef as ReactComponent };